import React from "react"
import { ExternalLink } from "../../components/footer"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Toggle from "../../components/toggle"
import { InternalLink } from "../about"

const TermsAndConditionsPage = ({ location }) => {
  return (
    <Layout location={location}>
      <SEO title="Big Tip Pro | Terms and Conditions" />
      <Toggle location={location} />
      <section>
        <h1>Big Tip Pro</h1>
        <h2>Terms and Conditions</h2>
        <p>
          By downloading or using the Big Tip Pro downloadable application
          ("app"), these terms will automatically apply to you – you should make
          sure therefore that you read them carefully before using the app. You
          are not allowed to copy or modify the app, any part of the app, or
          Pedro Cerna's (collectively described as "Pedro Cerna", "I", "my",
          "me") trademarks in any way. You are not allowed to attempt to extract
          the source code of the app, and you also shouldn't attempt to
          translate the app into other languages or make derivative versions.
          Using the app does not give you ownership of any intellectual property
          rights in the app or the content you access. You may not use content
          from the app unless you obtain permission from Pedro Cerna or are
          otherwise permitted by law. The app itself, and all of the trademarks,
          copyright, database rights, and other intellectual property rights
          related to it, still belong to Pedro Cerna.
        </p>
        <p>
          Do not misuse the app. For example, do not interfere with the app or
          try to access it using a method other than the interface and the
          instructions that I provide. You may use my app only as permitted by
          law. I may suspend or stop providing the app to you if you do not
          comply with my terms or policies or if I am investigating suspected
          misconduct. These terms do not grant you the right to use any branding
          or logos used in my app. Do not remove, obscure, or alter any legal
          notices displayed in or along with my app. In connection with your use
          of the app, I may send you service announcements, administrative
          messages, and other information. You may opt out of some of those
          communications. The app is available on mobile devices. Do not use the
          app in a way that distracts you and prevents you from obeying traffic
          or safety laws.
        </p>
        <p>
          Pedro Cerna is committed to ensuring that the app is as useful and as
          efficient as possible. I am constantly changing and improving the app.
          For that reason, I reserve the right to make changes to the app, at
          any time and for any reason.
        </p>
        <p>
          The Big Tip Pro app may use third-party services that store and
          process Personal Information that you have provided to me, to use my
          app. It is your responsibility to keep your phone and access to the
          app secure. I therefore recommend that you do not jailbreak or root
          your phone, which is the process of removing software restrictions and
          limitations imposed by the official operating system of your device.
          It could make your phone vulnerable to malware/viruses/malicious
          programs, compromise your phone's security features, and it could mean
          that the Big Tip Pro app will not work properly or at all.
        </p>
        <p>
          The app does use third-party services that declare their terms and
          conditions.
        </p>
        <p>
          Links to terms and conditions of third-party service providers used by
          the app are listed below.
        </p>
        <ul style={{ listStyle: "none" }}>
          <li>
            <p>
              <ExternalLink
                title="Google Play Services"
                href="https://policies.google.com/terms"
                target="_blank"
                rel="nofollow noreferrer noopener"
              >
                Google Play Services
              </ExternalLink>
            </p>
          </li>
          <li>
            <p>
              <ExternalLink
                title="Expo"
                href="https://expo.dev/terms"
                target="_blank"
                rel="nofollow noreferrer noopener"
              >
                Expo
              </ExternalLink>
            </p>
          </li>
        </ul>
        <p>
          You should be aware that there are things that Pedro Cerna will not
          take responsibility for. Certain functions of the app will require the
          app to have an active internet connection. The connection can be Wi-Fi
          or provided by your mobile network provider, but Pedro Cerna cannot
          take responsibility for the app not working at full functionality if
          you do not have access to Wi-Fi, and/or if you do not have any of your
          data allowance left.
        </p>
        <p>
          If you are using the app outside of an area with Wi-Fi, you should
          remember that the terms of the agreement with your mobile network
          provider will still apply. As a result, you may be charged by your
          mobile provider for the cost of data for the duration of the
          connection while accessing the app, or other third-party charges. In
          using the app, you are accepting responsibility for any such charges,
          including, but not limited to, roaming data charges if you use the app
          outside of your home territory (i.e. region or country) without
          turning off data roaming. If you are not the bill payer for the device
          on which you are using the app, please be aware that I assume that you
          have received permission from the bill payer to use the app.
        </p>
        <p>
          Along the same lines, Pedro Cerna cannot take responsibility for the
          way you use the app, for example, you need to make sure that your
          device stays charged – if it runs out of battery and you cannot turn
          it on to access the app, Pedro Cerna cannot accept responsibility.
        </p>
        <p>
          With respect to Pedro Cerna's responsibility for your use of the app,
          when you are using the app, it's important to bear in mind that
          although I endeavor to ensure that it is updated and correct at all
          times, I do rely on third parties to provide information to me so that
          I can make it available to you. Pedro Cerna is not liable for any
          loss, direct or indirect, you experience as a result of relying
          entirely on the app's functionality.
        </p>
        <p>
          At some point, I may wish to update the app and you will need to
          download the updates if you want to keep using the app. Pedro Cerna
          does not promise that updates to the app will always be relevant to
          you and/or work with the Android and iOS version that you have
          installed on your device. However, you promise to always accept
          updates to the application when offered to you. I may also wish to
          stop providing the app, and may terminate use of it at any time
          without giving notice of termination to you. Unless I tell you
          otherwise, upon any termination, (a) the rights and licenses granted
          to you in these terms will end; (b) you must stop using the app, and
          (if needed) delete it from your device.
        </p>
        <h3>Liability For The App</h3>
        <p>
          WHEN PERMITTED BY LAW, PEDRO CERNA, AND PEDRO CERNA'S SUPPLIERS AND
          DISTRIBUTORS, WILL NOT BE RESPONSIBLE FOR LOST PROFITS, REVENUES, OR
          DATA, FINANCIAL LOSSES, OR DIRECT OR INDIRECT, SPECIAL, CONSEQUENTIAL,
          EXEMPLARY, OR PUNITIVE DAMAGES. TO THE EXTENT PERMITTED BY LAW, THE
          TOTAL LIABILITY OF PEDRO CERNA, AND PEDRO CERNA'S SUPPLIERS AND
          DISTRIBUTORS, FOR ANY CLAIMS UNDER THESE TERMS, INCLUDING FOR ANY
          IMPLIED WARRANTIES, IS LIMITED TO THE AMOUNT YOU PAID PEDRO CERNA FOR
          USE OF THE BIG TIP PRO DOWNLOADABLE APPLICATION (OR, IF PEDRO CERNA
          CHOOSES, TO SUPPLY YOU WITH THE BIG TIP PRO DOWNLOADABLE APPLICATION
          AGAIN). IN ALL CASES, PEDRO CERNA, AND PEDRO CERNA'S SUPPLIERS AND
          DISTRIBUTORS, WILL NOT BE LIABLE FOR ANY LOSS, DIRECT OR INDIRECT, OR
          DAMAGE.
        </p>
        <h3>Changes To These Terms And Conditions</h3>
        <p>
          I may update my Terms and Conditions from time to time. Thus, you are
          advised to review this page periodically for any changes. I will
          notify you of any changes by posting the new Terms and Conditions on
          this page.
        </p>
        <p>
          If it occurs that a specific term is not enforceable, this will not
          affect any other terms in my Terms and Conditions.
        </p>
        <p>These Terms and Conditions are effective as of November 28, 2021.</p>
        <h3>Contact Me</h3>
        <p>
          If you have any questions, do not hesitate to contact me at{" "}
          <ExternalLink href="mailto:pedro.d.cerna@gmail.com">
            pedro.d.cerna@gmail.com
          </ExternalLink>
          .
        </p>
        <h3>Relevant Links</h3>
        <p>
          <InternalLink
            fade
            to="/big-tip-pro/privacy-policy/"
            duration={0.3}
            title="Big Tip Pro Privacy Policy"
          >
            Privacy Policy
          </InternalLink>
        </p>
      </section>
    </Layout>
  )
}

export default TermsAndConditionsPage
